import Empresa, { FinderEmpresas, RetornoEmpresa } from 'Interface/Empresas';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'Empresas';

const url = '/empresas';

const apiExtendida = api.enhanceEndpoints({
    addTagTypes: [tag],
}).injectEndpoints({
    endpoints: construtor => ({
        recuperarEmpresas: construtor.query<FinderEmpresas, Parametros | void>({
            query: (params) => `${url}?${paramsParaString(params)}`,
            providesTags: (resultado) => resultado?.empresas
                ? [
                    ...resultado.empresas.map(({ id }) => ({ type: tag, id } as const)),
                    { type: tag, id: 'LISTA' },
                ]
                : [{ type: tag, id: 'LISTA' }],
        }),
        recuperarEmpresa: construtor.query<RetornoEmpresa, string | number | Parametros>({
            query: params => {
                let id: number;
                let query: Parametros = {};

                if (['string', 'number'].includes(typeof params)) {
                    id = params as number;
                } else {
                    params = params as Parametros;

                    id = params.id as number;
                    query = paramsParaString(params);
                }

                return `${url}/${id}?${query}`;
            },
            providesTags: (resultado, erro, params) => {
                let id: number;

                if (['string', 'number'].includes(typeof params)) {
                    id = params as number;
                } else {
                    params = params as Parametros;

                    id = params.id as number;
                }

                return [{ type: tag, id }];
            },
        }),
        adicionarEmpresa: construtor.mutation<Empresa, Partial<Empresa>>({
            query: (dados) => ({ url: url, method: 'POST', body: formData(dados, 'POST') }),
            invalidatesTags: (resultado, erro) => !erro ? [{ type: tag, id: 'LISTA' }] : [],
        }),
        editarEmpresa: construtor.mutation<Empresa, Partial<Empresa> & Pick<Empresa, 'id'>>({
            query: ({ id, ...dados }) => ({ url: `${url}/${id}`, method: 'POST', body: formData(dados, 'PUT') }),
            invalidatesTags: (resultado, erro, { id }) => !erro ? [{ type: tag, id }] : [],
        }),
    }),
    overrideExisting: false,
});

export const {
    useRecuperarEmpresasQuery,
    useRecuperarEmpresaQuery,
    useAdicionarEmpresaMutation,
    useEditarEmpresaMutation,
} = apiExtendida;
